export enum MiniIframeEvent {
  PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
  GO_BACK = 'GO_BACK',
  ASK_TOKEN = 'ASK_TOKEN',
}
